import React, { useEffect, useState } from "react";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import { Loading, LoadTable, OutsideClick } from "../../Components";
import { useQuery } from "@apollo/client";
import { branchWithuserFilter, GET_CN_TRACKING_REPORT } from "../../../Utils/AllPagesQuriesAndMutations";
import { ConvertDateValues } from "../../custom_hooks/ChangeDateValues";
import "./StockReport.scss";
import { BsChevronDown } from "react-icons/bs";
import { getBranchCode } from "../../../CommonFunction/GetUserInfo";

let statusTab = [
  { name: "Godown Stock" },
  { name: "In Transit" },
  { name: "Inward" },
  { name: "Arrival" },
  { name: "All Godown" },
];

const StockReport = () => {
  const [Tab, SetTab] = useState("Godown Stock");
  const [isLoading, setIsLoading] = useState(true);
  const [formdata, setFormData] = useState([]);
  const [BranchData, setBranchData] = useState([]);
  const [branchIdArr, setBranchIdArr] = useState([]);
  const [dropdownToggle, setDropdowmToggle] = useState(false);
  const [SelectAllBranch, setSelectAllBranch] = useState(false);
  const { data, loading, error, refetch } = useQuery(GET_CN_TRACKING_REPORT, {
    variables: { type: Tab },
  });
  const { data: branchData } = useQuery(branchWithuserFilter);

  useEffect(() => {
    if (data) {
      setFormData(ConvertDateValues(data?.getLRTrackingReport));
    }
  }, [data]);

  useEffect(() => {
    if (branchData) {
      setBranchData(branchData?.SearchBranchAsPerUserRightWithCompanyId);
    }
  }, [branchData]);

  useEffect(() => {
    const fetchBranchCode = async () => {
      try {
        const BranchData = await getBranchCode();
        setBranchIdArr((prev) => [...prev, BranchData?.BranchCode]);
      } catch (error) {
        console.error("Error fetching branch code:", error);
      }
    };

    fetchBranchCode();
  }, []);

  useEffect(() => {
    if (Tab) {
      refetch({ type: Tab });
    }
  }, [Tab]);

  useEffect(() => {
    if (branchIdArr) {
      sessionStorage.setItem("UserSelectedBranch", JSON.stringify(branchIdArr));
      refetch({ type: Tab });
    }
  }, [branchIdArr]);

  useEffect(() => {
    return () => {
      sessionStorage.setItem("UserSelectedBranch", JSON.stringify({}));
    };
  }, []);

  const toggleBranchId = (branchId) => {
    setBranchIdArr((prev) => (prev.includes(branchId) ? prev.filter((id) => id !== branchId) : [...prev, branchId]));
  };

  return (
    <div>
      <div>
        <p style={{ margin: "0px", padding: "5px", paddingLeft: "10px" }}>{"Stock Report"}</p>
        <div className="hr1"></div>
        <div className="tabdiv">
          <Tabs tabs={statusTab} SetTabPage={SetTab} />
          <div>
            <div>
              <div className="CheckInput" onClick={() => setDropdowmToggle(true)}>
                <span>Select Branch</span>
                <BsChevronDown type="button" className={"icondown"} onClick={() => {}} />
              </div>
              {dropdownToggle && (
                <OutsideClick setToggled={() => setDropdowmToggle(false)}>
                  <div className="branchDD">
                    {BranchData && BranchData.length > 0 && (
                      <div>
                        <input
                          type="checkbox"
                          name=""
                          checked={SelectAllBranch}
                          id=""
                          onChange={(el) => {
                            let ids = BranchData.map((e) => e?.Unique_Id);
                            setBranchIdArr(ids);
                            setSelectAllBranch(el.target.checked);
                          }}
                        />
                        <div>Select All</div>
                      </div>
                    )}
                    {BranchData &&
                      BranchData.length > 0 &&
                      BranchData.map((e) => (
                        <div>
                          <input
                            type="checkbox"
                            name=""
                            checked={branchIdArr?.includes(e?.Unique_Id)}
                            id=""
                            onChange={(el) => toggleBranchId(e?.Unique_Id)}
                          />
                          <div>{e?.Name || ""}</div>
                        </div>
                      ))}
                  </div>
                </OutsideClick>
              )}
            </div>
          </div>
        </div>
      </div>
      {
        <>
          {loading && (!formdata || formdata?.length === 0) && <Loading />}
          {!loading && (!data?.getLRTrackingReport || data?.getLRTrackingReport?.length === 0) && (
            <p className="DataNotAvailable">Data not Available</p>
          )}
          {formdata && formdata?.length > 0 && (
            <>
              {loading && <div className="loader-line-div" />}

              <LoadTable title={`Stock_Report`} data={formdata} loading={""} error={error} Tab={Tab} />
            </>
          )}
        </>
      }
    </div>
  );
};

export default StockReport;
